import PingHandlerActionTypes from './ping-handler.types';

const INITIAL_STATE = {
  source: null,
  target: null,
  status: null,
  error: null,
};

const pingHandlerReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PingHandlerActionTypes.SET_CURR_SOURCE:
      return {
        ...state,
        source: action.payload,
      };

    case PingHandlerActionTypes.SET_CURR_TARGETS:
      return {
        ...state,
        target: action.payload,
      };

    case PingHandlerActionTypes.PING_FAILURE:
    case PingHandlerActionTypes.PING_BY_ID_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    case PingHandlerActionTypes.PING_SUCCESS:
    case PingHandlerActionTypes.PING_BY_ID_SUCCESS:
      return {
        ...state,
        status: action.payload,
      };

    default:
      return state;
  }
};

export default pingHandlerReducer;
